import { createSelector } from '@ngrx/store';
import { detailedInstallerProfileContext } from './installer-profile.selectors';


export const installerCommercialWorkPercentage = createSelector(
  detailedInstallerProfileContext,
  (context) => context?.installer?.type === 'INSTALLER_TEAM_LEAD' ? context.installer.commercialWorkPercentage : undefined,
);
